import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../enums/FormMode'
import { useCrudFormStore } from '../../Store/hooks/useStore'

export const EditButton = () => {
  const { setMode, mode } = useCrudFormStore(state =>
    pick(state, ['setMode', 'mode'])
  )

  const handleClick = () => {
    setMode(mode === FormMode.READ ? FormMode.UPDATE : FormMode.READ)
  }

  return mode === FormMode.READ ? (
    <Button ghost type='primary' onClick={handleClick}>
      编辑
    </Button>
  ) : (
    <Button type='default' onClick={handleClick}>
      取消
    </Button>
  )
}
